import { IntegrationCategories } from 'models/integrations/integrationCategories';
import { IntegrationTypes } from 'models/integrations/integrationTypeHandler';
import { Integration } from './integration';
import { IntegrationChecks } from './integrationCheckHandler';
import { IntegrationAuthModes, IntegrationConnectionTypes } from './integrationConnectionHandler';
import { IntegrationGroups } from './integrationGroupHandler';

export class IntegrationType {
  integrationTypeId: IntegrationTypes;

  integrationCategories: IntegrationCategories[];

  integrationGroupId: IntegrationGroups;

  integrationCheckId: IntegrationChecks;

  integrationConnectionTypeId: IntegrationConnectionTypes;

  authMode: IntegrationAuthModes;

  integration: Integration | undefined;

  constructor() {
    this.integrationTypeId = IntegrationTypes.NotSet;
    this.integrationCategories = [];
    this.integrationGroupId = IntegrationGroups.NotSet;
    this.integrationCheckId = IntegrationChecks.NotSet;
    this.integrationConnectionTypeId = IntegrationConnectionTypes.None;
    this.authMode = IntegrationAuthModes.None;
  }
}
